<template>
    <div class="routeinfos">

        <UploadedImage :image-path="BPRoute.MainPic"/>
        <div class="infos">

            <template v-if="language=='de'">
                <h1>{{ BPRoute.de.Titel }}</h1>
                <p>{{ BPRoute.de.Kurzbeschreibung }}</p>
            </template>
            <template v-if="language=='pl'">
                <h1>{{ BPRoute.pl.Titel }}</h1>
                <p>{{ BPRoute.pl.Kurzbeschreibung }}</p>
            </template>

            <div class="waypoints">

                <ul>
                    <li v-for="waypoint in BPfilteredWaypoints" v-bind:key="waypoint.id">
                        <router-link :to="{ name: 'waypoint', params: { waypointId: waypoint.id }}">
                            <span>
                            <template v-if="language=='de'">
                                {{ waypoint.de.Titel }}
                            </template>
                            <template v-if="language=='pl'">
                                {{ waypoint.pl.Titel }}
                            </template>
                                <Quizstatus :waypointId="waypoint.id"></Quizstatus>

                            </span>

                            <font-awesome-icon icon="chevron-right" class="pfeil" size="lg"/>

                        </router-link>
                    </li>
                </ul>
            </div>
            <Punktkarte :waypoints="BPfilteredWaypoints"></Punktkarte>
        </div>
    </div>
</template>

<script type="text/babel">

    import Backbutton from "../components/Backbutton";
    import UploadedImage from "../components/UploadedImage";
    import Punktkarte from "../components/Punktkarte";
    import Quizstatus from "../components/Quizstatus";

    export default {
        name: 'routeView',
        props: ['routeId'],
        components: {Quizstatus, UploadedImage, Backbutton, Punktkarte},
        computed: {
            language: function () {
                return this.$root.$i18n.locale;
            },
            BPRoute: function () {
                let self = this;
                return this.$root.BPRoutes.find((item) => item.id === self.routeId)
            },
            BPfilteredWaypoints() {
                // ALLE: return this.$root.BPPoints
                let bproute = this.BPRoute;
                let BPPoints = this.$root.BPPoints;
                //console.log(bproute.Punkte)
                let list = [];

                bproute.Punkte.map(function (value, key) {
                    let ret = BPPoints.filter((item) => item.id == value)
                    //console.log(ret);
                    if (ret && ret[0]) {
                        list.push(ret[0]);
                    }
                    //console.log(value);
                });


                return list;
                //  return this.$root.BPPoints.filter((item) => item.routeid == self.routeId)
                // return this.$root.BPPoints.filter((item) => bproute.Punkte.includes(item.id))
            }
        }
    }
</script>
